<template>
    <modal name="userdetail" :width="430" height="auto" :scrollable="true" @before-open="beforeOpen">
      <div class="modal-content modal-edit-character">
        <div class="modal-body">
          <div class="modal-edit-image">
            <img :src="photo_url.large_version" v-if="photo_url" alt="image"/>
            <button type="button" class="close" @click="hide('userdetail')">
              <em class="icon-close"></em>
            </button>
          </div>
          <div class="modal-edit-title">{{first_name}} {{last_name}}</div>
          <div class="modal-edit-text">{{email}}</div>
        </div>
        <div class="modal-footer">
            <!-- <div class="data-delete-dropdown">
              <button type="button" class="btn danger dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Delete
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <div class="data-popper-title">
                  Are you sure you want to delete this character?
                </div>
                <div class="data-popper-footer">
                  <a class="btn default">cancel</a>
                  <a class="btn primary" @click="deleteCharacter(user_id)">Ok</a>
                </div>
              </div>
            </div> -->
          <button type="button" class="btn primary" @click="show('editUser',{user_id : user_id })">Edit User</button>
        </div>
      </div>
    </modal>
</template>
<script>
import api from '../../services/api'
import { utilFunctionService } from "@/utils/utils.service";
export default {
    name: 'user-detail',
    props: {
      method: { type: Function },
    },
    data() {
        return {
            first_name: '',
            last_name:'',
            photo_url : '',
            email: '',
            user_id : '',
            url: utilFunctionService.getImageUrl()
        }
    },
    methods: {
        beforeOpen (event) {
            this.user_id = event.params.user_id
            this.getUsersDetails(this.user_id)
        },
        getUsersDetails(user_id)
        {
            api
            .getUsersDetails(user_id)
            .then(res => {
            this.first_name = res.data.data.attributes.first_name
            this.last_name = res.data.data.attributes.last_name
            this.photo_url = res.data.data.attributes.photo_url
            this.email = res.data.data.attributes.email
            })
            .catch();
        },
        hide(modal) {
          this.clearFormdata()
          this.$parent.hide(modal)
        },
        clearFormdata() {
          this.first_name=  '';
          this.last_name=  '';
          this.photo_url=  '';
          this.email=  '';
          this.user_id=  '';
        },
        show (model,params) {
          this.hide("userdetail");
          this.$modal.show(model,params);
        },
        uppercase(value, onlyFirstCharacter) {
          if (!value) {
            return "";
          }
          if (onlyFirstCharacter) {
            return value.charAt(0).toUpperCase() + value.slice(1);
          } else {
            return value.toUpperCase();
          }
        }
    }
};
</script>
